import cronstrue from "cronstrue";

export function describeCronSchedule(expression) {
  if (!expression?.trim()) return "";
  try {
    return cronstrue.toString(expression.trim(), { use24HourTimeFormat: true });
  } catch {
    return "Invalid cron expression";
  }
}

export function isValidCronSchedule(expression) {
  if (!expression?.trim()) return false;
  try {
    cronstrue.toString(expression.trim());
    return true;
  } catch {
    return false;
  }
}
